module.exports = __webpack_public_path__ + "img/product-1-thumb-9.c6ba4a5f.jpg";